import React, { useState } from "react";
import "./DiscountBanner.css";
import images from "../../../../utilities/images/images";
import { toastifyMessage } from "../../../../custom_utilities/toastify_config";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import uiActions from "../../../../redux/ui/action";

const DiscountBanner = ({
  description,
  discountPercent,
  couponNote,
  history,
  packageId,
  couponCode,
}) => {
  const [finalAmount, setFinalAmount] = useState(0);
  const [couponDiscount, setCouponDiscount] = useState(0);

  const dispatch = useDispatch();

  const startLoading = () => {
    dispatch(uiActions.startLoading());
  };

  const finishLoading = () => {
    dispatch(uiActions.finishLoading());
  };
  const paymentDetails = useSelector(
    (state) => state.paymentReducer.ccAvenueDetails
  );
  const userId = useSelector((state) => state.auth.user.user_id);
  const loader = useSelector((state) => state.ui.loader);
  const handleUpgradeClick = async () => {
    if (packageId) {
      // history.push(`/package/${packageId}`);

      history.push({
        pathname: `/package/${packageId}`,
        state: couponCode,
      });

      // if (couponCode.length === 0) {
      //   alert("Please Enter the Coupon Code");
      //   return;
      // }

      // startLoading();
      // try {
      //   const payloadData = {
      //     is_coupon: true,
      //     user_id: userId,
      //     package_id: packageId,
      //     order_id: paymentDetails.Order_Id,
      //     // amount:
      //     //   parseFloat(packageData?.price_details.course_price) -
      //     //     parseFloat(packageData?.price_details.discount) || 0,
      //     coupon_code: couponCode,
      //   };

      //   const response = await axios.post(
      //     "https://learning.motion.ac.in/motioneducation/api/user/apply_couponweb",
      //     payloadData
      //   );

      //   if (response.data.status === 200) {
      //     finishLoading();
      //     toastifyMessage({
      //       status: response.data.data.status,
      //       message: response.data.data.message,
      //     });

      //     setFinalAmount(response.data.data.updated_amount);

      //     setCouponDiscount(finalAmount - response.data.data.updated_amount);
      //     // handleCloseCoupon()[];
      //   }
      // } catch (error) {
      //   console.error("Error applying coupon", error);
      //   // handleCloseCoupon();
      // }
    }
  };

  return (
    <div className="discount-banner-wrapper">
      <div className="discount-banner">
        <div className="discount-left">
          <p className="small-text">You have unlocked</p>
          <h2 className="discount-percent">
            {discountPercent !== undefined && discountPercent !== null
              ? `${discountPercent}%`
              : "No Discount"}
            <span>DISCOUNT</span>
          </h2>
        </div>
        <div className="discount-center">
          <p className="main-text">{description}</p>
          <p className="sub-text">{couponNote}</p>
        </div>
        <div className="discount-right">
          <button className="upgrade-button" onClick={handleUpgradeClick}>
            Upgrade Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscountBanner;
